import React from "react";
import TestBlocks from "./TestBlocks";

const Antenatal = () => {
    return (
        <TestBlocks />
    );
};

export default Antenatal;
